import script from "./PasswordResetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetPage.vue?vue&type=style&index=0&id=6ff06b9e&lang=scss"

const __exports__ = script;

export default __exports__